// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/11/2023
 */

.CheckoutSteps_container__0SnP5 {
    padding: 1rem 2.5rem;
    padding-bottom: 0;
}

.CheckoutSteps_stepper__Pqf5I {
    width: 80%;
    margin: 0 auto;
}

.CheckoutSteps_label__OXAnI span {
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
}

/* for mobile */
@media (max-width: 770px) {
    .CheckoutSteps_container__0SnP5 {
        padding: 0;
        padding-top: 2rem;
    }
    .CheckoutSteps_label__OXAnI span {
        font-size: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/CheckoutSteps.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 3/11/2023\r\n */\r\n\r\n.container {\r\n    padding: 1rem 2.5rem;\r\n    padding-bottom: 0;\r\n}\r\n\r\n.stepper {\r\n    width: 80%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.label span {\r\n    font-size: 1.25rem;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .container {\r\n        padding: 0;\r\n        padding-top: 2rem;\r\n    }\r\n    .label span {\r\n        font-size: 1rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CheckoutSteps_container__0SnP5`,
	"stepper": `CheckoutSteps_stepper__Pqf5I`,
	"label": `CheckoutSteps_label__OXAnI`
};
export default ___CSS_LOADER_EXPORT___;
